'use strict';

var RulesPanelDirective = function RulesPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rules-panel.html'),
    controller: 'RulesPanelController',
    link: function link() {}
  };
};
RulesPanelDirective.$inject = [];
module.exports = RulesPanelDirective;